"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Connection = exports.InMemorySigner = void 0;
var Networks_1 = require("./Networks");
var taquito_1 = require("@taquito/taquito");
var signer_1 = require("@taquito/signer");
Object.defineProperty(exports, "InMemorySigner", { enumerable: true, get: function () { return signer_1.InMemorySigner; } });
var tzip16_1 = require("@taquito/tzip16");
var Connection = /** @class */ (function () {
    function Connection(_config) {
        this._config = _config;
        var provider = _config.provider, signer = _config.signer, confirmationConfig = _config.confirmationConfig;
        this.setProvider(provider, signer, confirmationConfig);
    }
    Connection.fromConfigs = function (configs) {
        var e_1, _a;
        var connections = {};
        try {
            for (var _b = __values(Object.keys(configs)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var network = _c.value;
                // Create the connection
                var connection = new Connection(configs[network]);
                var networkStr = network.toLowerCase();
                connections[networkStr] = connection;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return connections;
    };
    Connection.fromNetwork = function (network) {
        network = network.toLowerCase();
        var provider = (0, Networks_1.getProvider)(network);
        if (!provider) {
            throw Error("Provider not available");
        }
        return new Connection({
            provider: provider,
        });
    };
    Connection.fromNode = function (node) {
        return new Connection({
            provider: node,
        });
    };
    Connection.prototype.setProvider = function (provider, signer, confirmationConfig) {
        this._client = new taquito_1.TezosToolkit(provider);
        this._client.addExtension(new tzip16_1.Tzip16Module());
        if (confirmationConfig) {
            this._client.setProvider({
                config: confirmationConfig
            });
        }
        if (signer) {
            this.setSigner(signer);
        }
    };
    Connection.prototype.getProvider = function () {
        return this._client;
    };
    Connection.prototype.setSigner = function (signer) {
        if (!this._client) {
            throw Error("Please call \"setProvider(...)\" before calling setSigner");
        }
        this._config.signer = signer;
        this._client.setProvider({
            signer: signer,
        });
    };
    Connection.prototype.getSigner = function () {
        var signer = this._config.signer;
        if (!signer) {
            throw Error("Provider does not have a signer");
        }
        return signer;
    };
    Connection.prototype.getContract = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._client.contract.at(address)];
            });
        });
    };
    return Connection;
}());
exports.Connection = Connection;
//# sourceMappingURL=Connection.js.map